import { FC, PropsWithChildren } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';

const StepFormHint: FC<PropsWithChildren<PropsWithClassName>> = ({ children, className }) => (
  <p className={cn('font-dm text-xs italic text-black/45', className)}>{children}</p>
);

export default StepFormHint;
